import { useEffect, useState } from 'react';
import { Appointment } from '../../../../gql/graphql';
import styles from './NextAppointment.module.scss';
import { appointmentTimeWithTimeOffset } from '../../../_utils/AppointmentUtils';
import { secondsToText } from '../../../../ui/utils/time';
import { AppointmentFullInfoCard } from '../AppointmentFullInfoCard/AppointmentFullInfoCard';

interface NextAppointmentI {
  appointment: Appointment;
}

export const NextAppointment = ({ appointment }: NextAppointmentI) => {
  const [time, setTime] = useState<string>('...');
  const renderTimeLeft = () => {
    if (!appointment) return <div />;

    return <span>{time}</span>;
  };

  useEffect(() => {
    const calculateTime = () => {
      const actualDate = new Date();
      const appointmentTime = appointmentTimeWithTimeOffset(
        appointment?.dayOfAppointment,
        appointment?.Company?.timeZone
      );

      const localTime = secondsToText(
        (-1 * (actualDate.getTime() - appointmentTime.getTime())) / 1000,
        'hh:mm:ss'
      );

      setTime(localTime);
    };

    calculateTime();

    const intervalId = setInterval(calculateTime, 10);

    return () => {
      clearInterval(intervalId);
    };
  }, [appointment]);

  const renderNextAppointmentCard = () => {
    return <AppointmentFullInfoCard appointment={appointment} />;
  };

  if (!appointment) {
    return <div />;
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span>Siguiente cita en </span>
        {renderTimeLeft()}
      </div>
      {renderNextAppointmentCard()}
    </div>
  );
};
